import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { CompanyReferenceStatus, ICompanyBase } from '../../../types'
import { CompanyReferenceCard } from '../../molecules/CompanyReferenceCard'
import { PrimaryHeadingWithLink } from '../../atoms/PrimaryHeadingWithLink'

type Props = {
  company: ICompanyBase
}

export const CompanyProfileReferences: FC<Props> = ({ company }) => {
  const { t } = useTranslation(['p'])

  // status が show のリファレンスのみ取得
  const showStatusReferences = company.companyReferences?.nodes?.filter(
    (r) => r.status === CompanyReferenceStatus.SHOWN
  )
  if (showStatusReferences.length === 0) {
    return null
  }

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <PrimaryHeadingWithLink htmlTagType='h2' href={`/companies/${company.slug}/references`}>
          {t('応援コメント')}
        </PrimaryHeadingWithLink>
      </div>
      <div className={styles.content}>
        <div className={styles.cardList}>
          {/* 最初の3つのみ表示 */}
          {showStatusReferences.slice(0, 3).map((reference) => {
            return (
              <div key={reference.id} className={styles.cardItem}>
                <CompanyReferenceCard item={reference} />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
